import { createRouter, useNavigate } from '@tanstack/react-router';

import { NotFound } from '@nesso/ui/blocks/not-found';

import { queryClient } from '@/app/providers/query-client';

import { routeTree } from './route-tree.gen';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <main className="flex min-w-0 flex-1">
            <NotFound
                actionLabel="Go to Practice Members"
                onAction={() => void navigate({ to: '/practice-members' })}
            />
        </main>
    );
}

export const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultNotFoundComponent: NotFoundPage,
    context: { queryClient },
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
